import { render } from "./MisEventosPage.vue?vue&type=template&id=59f4da67&scoped=true"
import script from "./MisEventosPage.vue?vue&type=script&lang=js"
export * from "./MisEventosPage.vue?vue&type=script&lang=js"

import "./MisEventosPage.vue?vue&type=style&index=0&id=59f4da67&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59f4da67"]])

export default __exports__